import { Action } from "@ngrx/store";

export const SAVING_PHARMACY = "[Medication] Loading pharmacy";

export class SavingPharmacy implements Action {
	readonly type = SAVING_PHARMACY;
}

export type Actions = SavingPharmacy;
